<forge-list dense (keyup)="onKeyUp($event)" class="nav-menu-context">
  @for (item of contextItems; track item) {
    <forge-list-item>
      <button #item autofocus type="button" (click)="onClick($event, item)">
        {{item.label}}
      </button>
    </forge-list-item>
  }
</forge-list>